(function () {
  var MODE_KEY = 'ksp_delivery_pref';
  var busy = false;
  var variantIds = { avisierung: 0, premium: 0 };

  function cartUrl(path) {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function setCartAttribute(key, value) {
    return fetch(cartUrl('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [key]: String(value) } }),
    }).catch(function () {});
  }

  function getSavedMode() {
    try {
      return sessionStorage.getItem(MODE_KEY) || 'shipping';
    } catch (e) {
      return 'shipping';
    }
  }

  function saveMode(mode) {
    try {
      sessionStorage.setItem(MODE_KEY, mode);
    } catch (e) {}
  }

  function applyMode(root, mode) {
    if (!root || (mode !== 'shipping' && mode !== 'pickup')) return;
    root.querySelectorAll('[data-ksp-mode]').forEach(function (tab) {
      var active = tab.getAttribute('data-ksp-mode') === mode;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-ksp-panel]').forEach(function (panel) {
      var active = panel.getAttribute('data-ksp-panel') === mode;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }

  function updateWeightDisplay(root, weightGrams) {
    if (!root || weightGrams == null) return;
    var kg = Math.round(Number(weightGrams) / 1000);
    root.setAttribute('data-weight-kg', String(kg));
    var weightEl = root.querySelector('.ksp-ship-box__weight');
    if (!weightEl) return;
    if (kg > 0) {
      weightEl.hidden = false;
      weightEl.innerHTML = 'Ca. ' + kg + '&nbsp;kg';
      setCartAttribute('ksp_weight_kg', kg);
    } else {
      weightEl.hidden = true;
    }
  }

  function publishCartUpdate(source, cartData) {
    if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    publish(PUB_SUB_EVENTS.cartUpdate, { source: source, cartData: cartData });
  }

  function fetchCart() {
    return fetch(cartUrl('cart.js')).then(function (response) {
      return response.json();
    });
  }

  function findLineKey(cart, variantId) {
    if (!cart || !cart.items || !variantId) return null;
    var id = Number(variantId);
    for (var i = 0; i < cart.items.length; i++) {
      if (Number(cart.items[i].variant_id) === id) return cart.items[i].key;
    }
    return null;
  }

  function variantInCart(cart, variantId) {
    return Boolean(findLineKey(cart, variantId));
  }

  function resolveVariantId(root, extra) {
    if (variantIds[extra]) return Promise.resolve(variantIds[extra]);

    var attrName = extra === 'avisierung' ? 'data-avisierung-variant-id' : 'data-premium-variant-id';
    var handleName = extra === 'avisierung' ? 'data-avisierung-handle' : 'data-premium-handle';
    var fromDom = Number(root.getAttribute(attrName) || 0);
    if (fromDom) {
      variantIds[extra] = fromDom;
      return Promise.resolve(fromDom);
    }

    var handle = root.getAttribute(handleName);
    if (!handle) return Promise.resolve(0);

    return fetch(cartUrl('products/' + handle + '.js'), {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        if (!response.ok) return 0;
        return response.json();
      })
      .then(function (product) {
        var id =
          product && product.variants && product.variants[0] ? Number(product.variants[0].id) : 0;
        variantIds[extra] = id;
        if (id) root.setAttribute(attrName, String(id));
        return id;
      })
      .catch(function () {
        return 0;
      });
  }

  function resolveAllVariantIds(root) {
    return Promise.all([
      resolveVariantId(root, 'avisierung'),
      resolveVariantId(root, 'premium'),
    ]);
  }

  function refreshCartUI() {
    var cartItems = document.querySelector('cart-items');
    var jobs = [];

    if (cartItems && typeof cartItems.onCartUpdate === 'function') {
      jobs.push(cartItems.onCartUpdate());
    }

    var footer = document.getElementById('main-cart-footer');
    if (footer && footer.dataset.id) {
      jobs.push(
        fetch(cartUrl('?section_id=' + footer.dataset.id), {
          headers: { Accept: 'text/html' },
        })
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var source = doc.getElementById('main-cart-footer');
            var target = document.getElementById('main-cart-footer');
            if (!source || !target) return;

            // Nur .js-contents ersetzen – Buttons/Modal bleiben (sonst stirbt Bestellanfrage-Listener)
            var sourceContents = source.querySelector('.js-contents');
            var targetContents = target.querySelector('.js-contents');
            if (sourceContents && targetContents) {
              targetContents.innerHTML = sourceContents.innerHTML;
            } else {
              target.innerHTML = source.innerHTML;
            }

            initRoot(document.querySelector('[data-ksp-shipping-hinweis]'));
          })
      );
    }

    return Promise.all(jobs);
  }

  function syncCheckboxState(root, cart) {
    if (!root || !cart) return;

    root.querySelectorAll('[data-ksp-extra]').forEach(function (input) {
      var extra = input.getAttribute('data-ksp-extra');
      var variantId = variantIds[extra] || 0;
      if (!variantId) {
        input.checked = false;
        input.disabled = true;
        return;
      }
      input.checked = variantInCart(cart, variantId);
      input.disabled = busy;
    });
  }

  function setExtrasBusy(root, isBusy) {
    busy = isBusy;
    if (!root) return;
    root.classList.toggle('ksp-ship-box--busy', isBusy);
    root.querySelectorAll('[data-ksp-extra]').forEach(function (input) {
      if (!input.disabled || !isBusy) input.disabled = isBusy;
    });
  }

  function setServiceVariantQuantity(variantId, quantity) {
    var updates = {};
    updates[String(variantId)] = quantity;
    return fetch(cartUrl('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates }),
    }).then(function (response) {
      return response.json();
    });
  }

  function removeAllServiceExtras() {
    var ids = [variantIds.avisierung, variantIds.premium].filter(Boolean);
    if (!ids.length) return Promise.resolve(null);

    return fetchCart().then(function (cart) {
      var updates = {};
      ids.forEach(function (variantId) {
        var lineKey = findLineKey(cart, variantId);
        if (lineKey) updates[lineKey] = 0;
      });
      if (!Object.keys(updates).length) return null;
      return fetch(cartUrl('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates }),
      }).then(function (response) {
        return response.json();
      });
    });
  }

  function handleExtraToggle(root, input) {
    if (busy || !root || !input) return;

    var extra = input.getAttribute('data-ksp-extra');
    var shouldEnable = input.checked;

    setExtrasBusy(root, true);

    resolveVariantId(root, extra)
      .then(function (variantId) {
        if (!variantId) {
          input.checked = false;
          throw new Error('missing-variant');
        }
        if (shouldEnable) {
          return setServiceVariantQuantity(variantId, 1);
        }
        return fetchCart().then(function (cart) {
          var lineKey = findLineKey(cart, variantId);
          if (!lineKey) return cart;
          var updates = {};
          updates[lineKey] = 0;
          return fetch(cartUrl('cart/update.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates }),
          }).then(function (response) {
            return response.json();
          });
        });
      })
      .then(function (response) {
        if (response && response.status) {
          input.checked = !shouldEnable;
          return;
        }
        return refreshCartUI().then(fetchCart);
      })
      .then(function (cart) {
        if (!cart || cart.status) return;
        publishCartUpdate('ksp-shipping-extras', cart);
        root = document.querySelector('[data-ksp-shipping-hinweis]') || root;
        refresh(cart, root);
      })
      .catch(function (error) {
        if (error && error.message !== 'missing-variant') {
          input.checked = !shouldEnable;
        }
      })
      .finally(function () {
        root = document.querySelector('[data-ksp-shipping-hinweis]') || root;
        setExtrasBusy(root, false);
      });
  }

  function refresh(cartData, root) {
    root = root || document.querySelector('[data-ksp-shipping-hinweis]');
    if (!root) return;

    applyMode(root, getSavedMode());

    if (cartData && cartData.items) {
      updateWeightDisplay(root, cartData.total_weight);
      syncCheckboxState(root, cartData);
      return;
    }

    var kg = Number(root.getAttribute('data-weight-kg') || '0');
    if (Number.isFinite(kg) && kg > 0) {
      setCartAttribute('ksp_weight_kg', kg);
    }

    fetchCart()
      .then(function (cart) {
        syncCheckboxState(root, cart);
      })
      .catch(function () {});
  }

  function initRoot(root) {
    if (!root) return;
    resolveAllVariantIds(root).then(function () {
      fetchCart().then(function (cart) {
        syncCheckboxState(root, cart);
      });
    });
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-ksp-mode]');
    if (!tab) return;
    var root = tab.closest('[data-ksp-shipping-hinweis]');
    if (!root) return;
    event.preventDefault();

    var mode = tab.getAttribute('data-ksp-mode');
    var previousMode = getSavedMode();
    saveMode(mode);
    applyMode(root, mode);
    setCartAttribute(MODE_KEY, mode);

    if (mode === 'pickup' && previousMode !== 'pickup') {
      setExtrasBusy(root, true);
      removeAllServiceExtras()
        .then(function () {
          return refreshCartUI().then(fetchCart);
        })
        .then(function (cart) {
          if (cart) publishCartUpdate('ksp-shipping-extras', cart);
          root = document.querySelector('[data-ksp-shipping-hinweis]') || root;
          refresh(cart, root);
        })
        .finally(function () {
          root = document.querySelector('[data-ksp-shipping-hinweis]') || root;
          setExtrasBusy(root, false);
        });
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-ksp-extra]');
    if (!input) return;
    var root = input.closest('[data-ksp-shipping-hinweis]');
    if (!root || getSavedMode() === 'pickup') {
      input.checked = false;
      return;
    }
    handleExtraToggle(root, input);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initRoot(document.querySelector('[data-ksp-shipping-hinweis]'));
      refresh();
    });
  } else {
    initRoot(document.querySelector('[data-ksp-shipping-hinweis]'));
    refresh();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'ksp-shipping-extras') return;
      requestAnimationFrame(function () {
        setTimeout(function () {
          var root = document.querySelector('[data-ksp-shipping-hinweis]');
          if (root) initRoot(root);
          refresh(event && event.cartData, root);
        }, 50);
      });
    });
  }
})();
